import PropTypes from 'prop-types';

export const AdjustmentsCollectionPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    account: PropTypes.string,
    amountFrom: PropTypes.string,
    adjustmentId: PropTypes.string,
    amount: PropTypes.number,
    annualCum: PropTypes.string,
    attachments: PropTypes.string,
    bookToTaxDescription: PropTypes.string,
    companyCode: PropTypes.string,
    countryTaxType: PropTypes.string,
    description: PropTypes.string,
    multiplier: PropTypes.number,
    frequency: PropTypes.string,
    type: PropTypes.string,
    adjustmentType: PropTypes.string,
    manualAmount: PropTypes.number,
    autoAdjustmentId: PropTypes.number,
  })
);
